import { useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { Popup } from '../styled';
import { Content, InputBox, StyledCheckbox } from './MultiselectView.styled';

export const MultiselectView = ({ showPopup, setValue, data, popupIsOpen, $popupIsOpen, selectAll, placeholder, input: { name, value } }) => {
  // console.log("value", value, data);
  const open = popupIsOpen || $popupIsOpen;
  const wrapper = useRef(null);

  const getDisplayedValue = () => {
    if (Array.isArray(value)) {
      let displayedValue = '';

      value.forEach((id) => {
        data.forEach((elem) => {
          if (id == elem.id) {
            if (displayedValue) {
              displayedValue += `, ${elem.name}`;
            } else {
              displayedValue += elem.name;
            }
          }
        });
      });
      return displayedValue;
    } else return '';
  };

  const getInputs = () => {
    if (Array.isArray(data)) {
      return data.map((elem) => {
        const valOk = isNaN(parseInt(elem.id)) ? elem.id : parseInt(elem.id);

        return (
          <StyledCheckbox key={elem.id} className="checkbox">
            <input
              id={'id' + elem.name}
              onChange={(e) => setValue(e, valOk)}
              type="checkbox"
              name={elem.name}
              checked={Array.isArray(value) ? value.includes(elem.id) || value.includes(parseInt(elem.id)) : false}
            />
            <label htmlFor={'id' + elem.name}>{elem.name}</label>
          </StyledCheckbox>
        );
      });
    }
  };

  /**
   * outside click
   * @param {*} event
   */
  const outsideClick = (event) => {
    if (!wrapper.current.contains(event.target)) {
      if (open) {
        showPopup();
      }
    }
  };

  // console.log("values.length === data.length", values.length === data.length, value, data);

  return (
    <Content ref={wrapper}>
      <InputBox onClick={showPopup}>
        <input placeholder={placeholder} value={getDisplayedValue()} disabled />
      </InputBox>
      <OutsideClickHandler onOutsideClick={outsideClick}>
        <Popup className="popup" $popupIsOpen={open}>
          <StyledCheckbox className="checkbox">
            <input id={name + 'all'} onChange={selectAll} checked={value.length === data.length} type="checkbox" name="all" />
            <label htmlFor={name + 'all'}>Все</label>
          </StyledCheckbox>
          {getInputs()}
        </Popup>
      </OutsideClickHandler>
    </Content>
  );
};
